import Backbone, {ModelSetOptions} from 'backbone';

import {HasOwnablePermissions, Owner, OwnerInfo} from 'auth/PermissionConstants';

interface LadderServerResponse extends HasOwnablePermissions {
  name: string;
  created_at: string;
  description?: string;
  ownerInfo: OwnerInfo;
  owner: Owner;
  owner_handle: string;
  band_sizes: Array<number>;
}

interface Ladder {
  get<K extends keyof LadderServerResponse>(key: K): LadderServerResponse[K];
  set<K extends keyof LadderServerResponse>(
    attributeName: K,
    value: LadderServerResponse[K],
    options?: Backbone.ModelSetOptions
  ): Ladder;
  set(obj: Partial<LadderServerResponse>, options?: ModelSetOptions): Ladder;
}

class Ladder extends Backbone.Model {
  override urlRoot = '/1/api/ladders/';

  bandSizes(): Array<number> {
    return this.get('band_sizes');
  }
}

class Ladders extends Backbone.Collection<Ladder> {
  static initClass(): void {
    this.prototype.model = Ladder;
  }
  override url = '/1/api/ladders/';
}
Ladders.initClass();

export {Ladder as Model, Ladders as Collection};
